
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.507 7.396a.868.868 0 01-.805-.556l-1.39-3.61H5.694L4.306 6.847a.87.87 0 01-.806.548H2.36v1.042h1.12L2.534 9.77v7h3.82v-2.778h7.29v2.778h3.82v-7l-.944-1.334h1.118v-1.04h-1.132zM6.402 4.27h7.196l1.131 2.952c.023.064.05.127.084.187H5.187c.033-.06.06-.123.084-.188L6.402 4.27zm-1.09 11.458H3.577v-1.951c.268.139.566.212.867.215h.869v1.736zm9.375 0v-1.736h.869c.302-.003.6-.076.867-.216v1.952h-1.735zm.869-2.777H4.444a.868.868 0 01-.867-.869v-1.979l.916-1.298a.878.878 0 01.694-.368h9.611a.878.878 0 01.695.368l.917 1.298v1.98c0 .473-.38.86-.854.868zM4.444 10.173h2.779v1.042H4.444v-1.042zm8.334 0h2.778v1.042h-2.778v-1.042z","fill":"#171C26","fill-rule":"evenodd"}})])
          )
        }
      }
    